const FunctionsGroup = (elements) => {
  if (elements.length < 1) return;

  elements.forEach(group => {
    init(group);
  });
  
  function init(group) {
    const items = Array.from(group.querySelectorAll('.functions-group__item'));

    items.forEach(item => {
      item.addEventListener('toggle', e => {
        const isOpen = e.target.open;
        if (isOpen) {
          setActiveItem(group, items.indexOf(e.target));
        }
      });
    });

    setActiveItem(group, 0);
  }

  function getActiveItemIndex(items) {
    const activeItem = items.find(item => item.open === true);
    return activeItem ? items.indexOf(activeItem) : 0;
  }

  function setActiveItem(group, index) {
    const imageActiveClass = 'active';
    const items = Array.from(group.querySelectorAll('.functions-group__item'));
    const images = Array.from(group.querySelectorAll('.functions-group__image img'));

    if (!index) {
      index = getActiveItemIndex(items);
    }

    images
      .filter(img => img.classList.contains(imageActiveClass))
      .forEach(img => img.classList.remove(imageActiveClass));
    images[index].classList.add(imageActiveClass);
  }
}

export default FunctionsGroup;



